"use strict";

module.exports = {
  SOURCE: 'source',
  TARGET: 'target'
};